export default {
  targetLocation: 'Target Location',
  targetUser: 'Target User',
  active: 'Active',
  inactive: 'Inactive',
  createdAt: 'Created At',
  noPermissions: 'No permissions assigned',
  // Permission types
  types: {
    LOCATION_MANAGEMENT: 'Location Management',
    BORROW_FOR_USER: 'Borrow for User',
    RESOURCE_MANAGEMENT: 'Resource Management'
  }
};
